import StepIcon from '@mui/material/StepIcon';
import { Theme } from '@mui/material/styles';

export type StepProps = {
  step: string;
};

const Step = ({ step }: StepProps) => {
  return (
    <StepIcon
      icon={step}
      sx={(theme: Theme) => {
        return {
          color: `${theme.palette.red[60]} !important`,
        };
      }}
    ></StepIcon>
  ) as React.ReactNode;
};

export default Step;
export { Step };
